import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMobileAuth } from '../MobileAuthProvider';
import SecuritySettings from '../../SecuritySettings';
import { logoutAllDevicesAction } from '../../authLogoutAll';

// /mobile/security: the shared security page. Leaving for sign-in happens before logout so the notice survives.
export default function MobileSecurity() {
  const { token, logout } = useMobileAuth();
  const navigate = useNavigate();
  const leave = (notice) => {
    navigate('/mobile/login', { replace: true, state: notice ? { notice } : undefined });
    logout();
  };
  return (
    <SecuritySettings token={token} onSignedOut={leave}
      onLogoutAll={() => logoutAllDevicesAction({ apiUrl: '', token, logout: () => leave() })} />
  );
}
